import {
    ResultObj,
    allFetch
} from "../Domain";


/**
 * @description 建立簽核資料(formdata)
 * {
 *   sosm_id:"簽核設定主項流水號",
 *   user_id:"使用者流水號",
 *   title:"主題",
 *   "sosd_id":value/file
 *   "sosd_id":value/file
 *   "sosd_id":value/file
 *   "sosd_id":value/file
 *    ...
 * }
 */

export interface SignOffLogCreateParams {
    sosm_id: string;
    user_id: string;
    title: string;
    [key: string]: string | File;
}

export const SignOffLogCreate = async function (obj: SignOffLogCreateParams): Promise<ResultObj> {
    let fileData = new FormData();
    for (let i in obj) {
        fileData.append(i, obj[i]);
    }
    return await allFetch<FormData>('SignOffLog/SignOffLogCreate', fileData);
};

export interface SignOffLogUpdateParams {
    sosm_id: string;
    user_id: string;
    title: string;
    so_id: string;
    sosd_ids?: string[]; // 使用字串陣列表示多個 sosd_id
    [key: string]: string | File | string[] | undefined;
}

/**
 * @description 修改簽核資料(formdata)
 * {
 *   sosm_id:"簽核設定主項流水號",
 *   user_id:"使用者流水號",
 *   title:"主題",
 *   so_id: "簽核資料流水號"
 *   "sosd_id":value/file
 *   "sosd_id":value/file
 *   "sosd_id":value/file
 *   "sosd_id":value/file
 *    ...
 * }
 */
export const SignOffLogUpdate = async function (obj: SignOffLogUpdateParams): Promise<ResultObj> {
    let fileData = new FormData();
    for (let i in obj) {
        fileData.append(i, obj[i] as any);
    }
    return await allFetch<FormData>('SignOffLog/SignOffLogUpdate', fileData);
};

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} so_id 簽核資料流水號
 */
export interface SignOffLogSubmitParams {
    sosm_id: string;
    so_id: string;
}

/**
 * 送審簽核資料
 * @returns 
 */
export const SignOffLogSubmit = async function (obj: SignOffLogSubmitParams): Promise<ResultObj> {
    return await allFetch('SignOffLog/SignOffLogSubmit', obj);
};

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} so_id 簽核資料流水號
 * @param {*} status 審核狀態
 * @param {*} note 備註
 */
export interface SignOffLogAuditParams {
    sosm_id: string;
    so_id: string;
    status: string;
    note: string;
}

/**
 * 審核簽核資料
 * @returns 
 */
export const SignOffLogAudit = async function (obj: SignOffLogAuditParams): Promise<ResultObj> {
    return await allFetch('SignOffLog/SignOffLogAudit', obj);
};

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} so_id 簽核資料流水號
 * @param {*} note 備註
 */
export interface SignOffLogCancelCreateParams {
    sosm_id: string;
    so_id: string;
    note: string;
}

/**
 * @description 申請撤銷簽核資料
 */
export const SignOffLogCancelCreate = async function (obj: SignOffLogCancelCreateParams): Promise<ResultObj> {
    return await allFetch('SignOffLog/SignOffLogCancelCreate', obj);
};

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} so_id 簽核資料流水號
 * @param {*} status 審核狀態
 * @param {*} note 備註
 */
export interface SignOffLogCancelAuditParams {
    sosm_id: string;
    so_id: string;
    status?: string;
    note?: string;
}

/**
 * @description 審核撤銷簽核資料
 */
export const SignOffLogCancelAudit = async function (obj: SignOffLogCancelAuditParams): Promise<ResultObj> {
    return await allFetch('SignOffLog/SignOffLogCancelAudit', obj);
};

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} user_id 使用者流水號
 * @param {*} ul_id 職務流水號
 * @param {*} title 標題
 * @param {*} statuses 審核狀態們
 * @param {*} search_condition_kvs 查詢條件們
 * @param {*} my_turn 是否輪到我審
 * @param {*} sort_name 排序依據 ex. 建立時間
 * @param {*} sort_order 排序順序 <正 | 倒>
 * @param {*} page 頁碼
 * @param {*} num_per_page 一頁幾筆
 */
export interface SignOffLogSearchParams {
    sosm_id: string;
    user_id: string;
    ul_id: string;
    title: string;
    statuses: string[];
    search_condition_kvs: { key: string, value: any }[];
    my_turn: "Y" | "N" | "";
    sort_name: string;
    sort_order: '正' | '倒' | "";
    page: number;
    num_per_page: number;
}

export type SignOffLogSearchResItem = {
    audit_level: string;
    cre_time: string;
    so_id: string;
    sosm_id: string;
    sosm_name: string;
    status: string;
    title: string;
    ul_code: string;
    ul_id: string;
    ul_name: string;
    user_id: string;
    user_name: string;
    user_username: string;
    [key: string]: any
}

/**
 * @description 查詢簽核資料
 */
export const SignOffLogSearch = async function (obj: SignOffLogSearchParams): Promise<ResultObj<SignOffLogSearchResItem[]>> {
    return await allFetch('SignOffLog/SignOffLogSearch', obj);
};

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} so_id 簽核資料流水號
 */
export interface SignOffLogDetailParams {
    sosm_id: string;
    so_id: string;
}

/**@description 簽核資料細項 (回傳) */
export interface SignOffLogDetailResItem {
    cre_time: string;
    so_id: string;
    status: string;
    title: string;
    ul_code: string;
    ul_id: number;
    ul_name: string;
    user_id: string;
    user_name: string;
    user_username: string;
    [key: string]: any
}

/**
 * @description 簽核資料細項
 */
export const SignOffLogDetail = async function (obj: SignOffLogDetailParams): Promise<ResultObj<SignOffLogDetailResItem[]>> {
    return await allFetch('SignOffLog/SignOffLogDetail', obj);
};






